// extracted by mini-css-extract-plugin
module.exports = {"VariantsFashion":"styles_VariantsFashion__uL0vP","input":"styles_input__d9hti","icon":"styles_icon__figcC","select":"styles_select__pavsU"};